import { BrowserRouter,Routes,Route } from "react-router-dom"
import { Box } from "@mui/material"
import{Navbar,Feed,Search,Channel, VideoDetail} from './component'
const App = () => 
   (
   <BrowserRouter>
   <Box sx={{backgroundColor:'red',marginTop:'0px'}}>
    <Navbar/>
    <Routes>
      <Route path="/" exact element={<Feed />}/>
      <Route path="/video/:id" exact element={<VideoDetail />}/>
      <Route path="/channel/:id" exact element={<Channel />}/>
      <Route path="/search/:searchTerm" exact element={<Search />}/>
    </Routes>
   </Box>
   </BrowserRouter>
  )


export default App